import { DeleteForever as TrashIcon, FactCheckOutlined as ListIcon } from '@mui/icons-material';
import GlobalButton, { GlobalButtonVariant } from '@/components/buttons/GlobalButton';

interface ListHeaderProps {
  count: number;
  onClearAll: () => void;
}

const ListHeader = ({ count, onClearAll }: ListHeaderProps) => {
  return (
    <div className='flex items-center justify-between mb-6 px-1'>
      <div className='flex items-center gap-3'>
        <div className='p-2.5 rounded-xl bg-[#ff7500] shadow-sm aspect-square flex items-center justify-center'>
          <ListIcon sx={{ fontSize: 24, color: 'white', opacity: 0.9 }} />
        </div>
        <div className='flex flex-col'>
          <h3 className='text-xl font-black text-gray-800 leading-tight'>
            Pedidos escaneados
          </h3>
          <span className='text-[13px] text-gray-400 font-medium leading-tight mt-0.5'>
            {count} {count === 1 ? 'escaneado' : 'escaneados'}
          </span>
        </div>
      </div>
      {count > 0 && (
        <GlobalButton
          variant={GlobalButtonVariant.secondaryButton}
          action={onClearAll}
          size='small'
        >
          <TrashIcon sx={{ fontSize: 16, mr: 0.5 }} />
          Borrar todo
        </GlobalButton>
      )}
    </div>
  );
};

export default ListHeader;
